module.exports = __webpack_public_path__ + "assets/img/free_6.51110164.png";